import React, { memo, useMemo, useCallback } from 'react';
import FullWidthModal from '../Modal/FullWidthModal';
import ModalHeader from '../ModalHeader/index';
import { LABEL, CUSTOM_MESSAGES } from '../../../veriables';
import cn from 'classnames';
import { TouchableButton, TouchableDiv } from '../Touchable/index';
import ConfirmationModal from '@components/common/Modal';
import styles from './tableCopy.module.scss';

const dateTimeFormat = item => {
  const dateObj = new Date(item.startDateTime);
  const date = dateObj.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
  const time = dateObj.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return { date, time };
};

const PartyRow = memo(({ item, serverAppTheme, onSelect, isSelected }) => {
  const { date, time } = useMemo(() => dateTimeFormat(item), [item]);
  return (
    <tr
      style={{
        borderBottom: serverAppTheme?.popupBorder,
        padding: '0 10px',
      }}
    >
      <td className={cn('col-1 px-0 py-2 fw-normal fs_16')}>
        <input
          type="checkbox"
          id={item.id}
          className={cn(styles.checkbox, styles.checkBoxSize)}
          onChange={e => {
            e.stopPropagation();
            onSelect(item, e.target.checked);
          }}
          style={{
            border: item.isCheck
              ? 'none'
              : serverAppTheme?.checkbox_border,
            '--checkbox-checked-color':
              serverAppTheme?.checkbox_check_color,
            '--checkbox-checked-bg':
              serverAppTheme?.checkbox_checked,
          }}
          checked={isSelected}
        />
      </td>
      <td className={cn('col-3 px-0 py-2 fw-normal fs_16')}>
        {item.eventNumber}
      </td>
      <td className={cn('col-4 px-0 py-2 fw-normal fs_16')}>
        {item.eventName}
      </td>
      <td className={cn('col-2 px-0 text-center py-2 fw-normal fs_16')}>
        {date}
      </td>
      <td className={cn('col-2 px-0 text-center py-2 fw-normal fs_16')}>
        {time}
      </td>
    </tr>
  );
});

const AttachToParty = props => {
  const {
    isPartyModal,
    setIsPartyModal,
    isOpenConfirmationParty,
    setOpenConfimrationParty,
    partyData,
    serverAppTheme,
    seat,
    loading,
    selectedPartyData,
    setSelectedPartyData,
    handleFinalClickAttchParty,
    handleAddPartyToCart,
    displaySideMenu,
  } = props;

  const handleCheckboxChange = useCallback(
    (items, checked) => {
      setSelectedPartyData(checked ? items : null);
    },
    [setSelectedPartyData]
  );

  return (
    <>
      {isPartyModal && (
        <FullWidthModal
          isOpen={isPartyModal}
          isModalCenter={true}
          customClass={cn('h-100')}
          customClass2="h-100 w-100 d-flex"
          customWidth={true}
          noBackground
          style={{
            width: '100%',
            margin: 'auto',
            height: '100%',
            backgroundColor: serverAppTheme?.popUp_bg,
            //border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            borderRadius: '16px',
          }}
        >
          <ModalHeader
            tileHeader={LABEL().ATP_ATTACH_TO_PARTY}
            stationName={seat?.stationName}
            seatNumber={seat?.number}
          />
          <div className="col-12 d-flex pt-20 h-auto justify-content-center">
            <div className="col-9 px-3 fs_20 fw-600 fw-normal text-center">
              {CUSTOM_MESSAGES().ATP_SELECT_PARTY_TO_CHECK}
            </div>
          </div>
          <div className="p-3" style={{ height: '60%' }}>
            <div
              className={cn('col-12 px-0 h-100')}
              style={{
                border: serverAppTheme?.popupBorder,
                borderRadius: '4px',
                overflow: 'scroll',
              }}
            >
              {' '}
              <table className={cn('w-100 h-100', styles.table)}>
                <thead className={styles.headerFixed}>
                  <tr
                    style={{
                      borderBottom: serverAppTheme?.popupBorder,
                      padding: '0 10px',
                    }}
                  >
                    <th className={cn('col-1 text-left py-1 px-0 fs_16')}>
                      {LABEL().ATP_SELECT}
                    </th>
                    <th className={cn('col-3 text-left p-1 fs_16')}>
                      {LABEL().ATP_EVENT_NUMBER}
                    </th>
                    <th className={cn('col-4 text-left p-1 fs_16')}>
                      {LABEL().ATP_EVENT_NAME}
                    </th>
                    <th className={cn('col-2 text-center p-1 fs_16')}>
                      {LABEL().ATP_START_DATE}
                    </th>
                    <th className={cn('col-2 text-center p-1 fs_16')}>
                      {LABEL().ATP_START_TIME}
                    </th>
                  </tr>
                </thead>
                <tbody className={cn('h-89')}>
                  {partyData.map(item => (
                    <PartyRow
                      key={item.id}
                      item={item}
                      serverAppTheme={serverAppTheme}
                      onSelect={handleCheckboxChange}
                      isSelected={selectedPartyData?.eventNumber === item.eventNumber}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className="d-flex justify-content-center"
            style={{ position: 'relative', top: '60px' }}
          >
            <div className="col-4 pr-1">
              <TouchableButton
                type="button"
                onClick={e => {
                  e.preventDefault();
                  setIsPartyModal(false);
                  setSelectedPartyData(null);
                }}
                className="btn44 w-100"
                style={{
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                  color: serverAppTheme?.cancleBtn_font,
                }}
                rippleEffect={true}
              >
                {LABEL().CANCEL}
              </TouchableButton>
            </div>
            <div className="col-4 pl-1">
              <TouchableButton
                type="button"
                className={cn('rounded btn-ripple btn44 w-100')}
                style={{
                  fontSize: '1.5rem',
                  fontWeight: displaySideMenu && '400',
                  background: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                  opacity: 1,
                }}
                onClick={event => {
                  event.preventDefault();
                  handleFinalClickAttchParty();
                }}
                rippleEffect={true}
              >
                {LABEL().ATP_ATTACH_TO_PARTY}
              </TouchableButton>
            </div>
          </div>
        </FullWidthModal>
      )}
      {isOpenConfirmationParty && (
        <ConfirmationModal
          isOpen={isOpenConfirmationParty}
          loading={loading}
          isModalCenter
          noBackground
          style={{
            backgroundColor: serverAppTheme?.popUp_bg,
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            borderRadius: '16px',
            width: '486px',
            margin: 'auto',
            minHeight: '216px',
          }}
          customClass="h-100 w-100"
          customClass2="h-100 w-100"
        >
          <div
            className="m-2 justify-content-center align-items-center text-center  h-100 "
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div className="col-12 py-2 fs_18 fw-700 text-center h-25">
              Are You Sure?
            </div>
            <div className="col-12 d-flex p-0 py-1 h-auto justify-content-center">
              <div className="col-9 px-3 fs_15 fw-normal text-center">
                {CUSTOM_MESSAGES().ATP_ATTACH_PARTY_CONFIRMATION_MSG}
              </div>
            </div>
            <div
              className="col-11 d-flex mt-2 justify-content-center align-items-center align-items-end text-center h-20 position-absolute"
              style={{ bottom: '26px', left: '20px' }}
            >
              <TouchableButton
                className={cn('col-6 h-100 mr-1 btn90 fs_24')}
                style={{
                  background: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                  color: serverAppTheme?.cancleBtn_font,
                }}
                type="button"
                onClick={e => {
                  setOpenConfimrationParty(false);
                  e.preventDefault();
                }}
                rippleEffect={true}
              >
                {LABEL().NO}
              </TouchableButton>
              <TouchableButton
                className={cn('col-6 h-100 ml-1 btn90 btn-ripple fs_24')}
                style={{
                  background: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                type="button"
                onClick={e => {
                  e.preventDefault();
                  handleAddPartyToCart();
                }}
                rippleEffect={true}
              >
                {LABEL().YES}
              </TouchableButton>
            </div>
          </div>
        </ConfirmationModal>
      )}
    </>
  );
};

export default memo(AttachToParty);
